import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #POPOVER
\*------------------------------------ */
[popover] {
  /**
  * Reset all default user agent styles - position: fixed, outline, margin: auto etc
  */
  position: unset;
  inset: unset;
  width: unset;
  height: unset;
  margin: unset;
  border: unset;
  padding: unset;
  color: unset;
  background-color: unset;
  overflow: unset;
}

/**
 * Popover -the main content wrapper of the header, body, and footer
 */
.cat-c-popover {
  position: relative;
}

/**
 * Popover panel
 */
.cat-c-popover__panel {
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  width: var(--cat-popover-panel-width, 20.25rem);
  background-color: var(--cat-theme-color-background-default);
  border-radius: var(--cat-border-radius-lg);
  box-shadow: var(--cat-theme-box-shadow-lg);
  /**
   * Active state for popover panel
   */
  /**
   * Adds a max width of 50rems to the popover panel
   */
  /**
   * Popover panel positioned to the top left on small screens
   */
}
.cat-is-active:not(.cat-c-popover--dynamic) .cat-c-popover__panel, .cat-is-active-dynamic .cat-c-popover__panel {
  opacity: 1;
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-popover__panel {
    overflow: auto;
  }
}
.cat-c-popover--lg .cat-c-popover__panel {
  width: 75vw;
  max-width: 50rem;
}
.cat-c-popover--responsive .cat-c-popover__panel {
  white-space: normal;
}

/**
 * Popover panel on small screens
 * 1) Makes the popover fixed and the width of the screen on small devices
 */
.cat-c-popover {
  /**
  * Adjust the popover panel to be full width on small screens
  */
  /**
  * Adjust the popover panel to be full height on small screens
  */
}
.cat-c-popover .cat-c-popover__panel-wrapper {
  display: none;
  z-index: var(--cat-z-index-500);
  max-height: var(--cat-auto-position-max-height);
  max-width: var(--cat-auto-position-max-width);
  overflow: var(--cat-auto-position-overflow);
  box-shadow: var(--cat-theme-box-shadow-lg);
}
.cat-c-popover .cat-c-popover__panel--full-screen {
  position: fixed;
  inset-block: 50% auto;
  inset-inline: 50% auto;
  transform: translate(var(--rtlTranslateX, -50%), -50%);
  margin: auto;
  width: 100vw;
  max-width: 100vw;
  max-height: 100vh;
  white-space: inherit;
  z-index: var(--cat-z-index-500);
}
.cat-c-popover .cat-c-popover__panel--responsive {
  height: 100vh;
  box-shadow: none;
  border-radius: 0;
}

/**
 * Popover header
 * 1) The header in the popover
 */
.cat-c-popover__header {
  padding: var(--cat-space-medium) var(--cat-space-medium) var(--cat-space-x-small);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
}

/**
 * Popover header content
* 1) The wrapper for content in a slot or cat heading
 */
.cat-c-popover__header-content {
  display: flex;
  align-items: center;
  align-self: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-basis: 100%;
  white-space: normal;
  word-break: break-word;
}

/**
 * Popover heading
 * 1) The heading text in the header
 */
.cat-c-popover__heading {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  word-break: break-word;
}

/**
 * Popover body
 * 1) The body/content in the popover
 */
.cat-c-popover__body {
  flex-basis: 100%;
  padding: var(--cat-popover-body-panel-padding-vertical, 0) var(--cat-popover-body-panel-padding-horizontal, 0);
  /**
   * Remove padding and overflow on color picker
   */
}
.cat-c-popover--no-scroll .cat-c-popover__body {
  overflow: none;
}

/**
 * Popover footer
 * 1) The footer in the popover
 */
.cat-c-popover__footer {
  padding: var(--cat-space-medium);
}

/**
 * Popover close button
 * The button that appears after the heading
 */
.cat-c-popover__close-button {
  margin-inline-start: var(--cat-space-x-small);
}

.cat-c-popover:not(.cat-c-popover--has-trigger) [part=part-trigger], .cat-c-popover:not(.cat-c-popover--has-footer) .cat-c-popover__footer, .cat-c-popover:not(.cat-c-popover--has-header) [part=part-header] {
  display: none;
}
`;
       